// Port of api/fuel/app/classes/controller/api/monty/views/field/remove.php
import DB from 'offline/db'
import Constants from 'offline/constants'

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var viewId = parseInt(params.view, 10) || 0
	var model = params.model || {}
	var rows = viewId ? DB.query('SELECT * FROM view WHERE user_id = ? AND view_id = ?', [userId, viewId]) : []

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!rows.length) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	var view = viewToArray(rows[0])
	var fields = []
	for (var i = 0; i < view.fields.length; i++) {
		if (view.fields[i].id !== model.id) fields.push(view.fields[i])
	}

	DB.run('UPDATE view SET view_fields = ? WHERE view_id = ?', [JSON.stringify(fields), viewId])
	rows = DB.query('SELECT * FROM view WHERE view_id = ?', [viewId])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: viewToArray(rows[0])
		}
	})
}
